export default "__VITE_ASSET__47d82e5a__"